module.exports = __webpack_public_path__ + "static/media/06soubu.2661165a.png";